export default __webpack_public_path__ + "dc450fbff0442b773537b131eb75ee9a.png";